import { render, staticRenderFns } from "./ChatActions.vue?vue&type=template&id=485281a0&scoped=true"
import script from "./ChatActions.vue?vue&type=script&lang=js"
export * from "./ChatActions.vue?vue&type=script&lang=js"
import style0 from "./ChatActions.vue?vue&type=style&index=0&id=485281a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485281a0",
  null
  
)

export default component.exports